export enum ExportMode {
    ByIdentifier,
    ByLogbookEntry
}